"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.atlas = void 0;
const ComponentType_1 = require("../components/ComponentType");
const UIComponentType_1 = require("../components/UIComponentType");
const UIComponent_1 = require("../config/UIComponent");
exports.atlas = {
    control: [
        {
            id: 1,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Controls',
                includeConnectionText: true,
            },
        },
        {
            id: 2,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    props: {
                        advancedScreenTitle: 'Inside Lights',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.LIGHT,
                            controlId: 1,
                            props: {
                                timeoutOverride: 10000,
                            },
                        },
                    ],
                    tileLabelOverride: 'Inside',
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.LIGHT,
                            controlId: 2,
                        },
                    ],
                    tileLabelOverride: 'Outside',
                },
            ],
        },
        {
            id: 3,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.AWNING,
                            controlId: 16,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.WINDOW_SHADE,
                            controlId: 14,
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.WINDOW_SHADE,
                            controlId: 15,
                        },
                    ],
                    tileLabelOverride: 'Shades',
                },
            ],
        },
        {
            id: 4,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'HVAC',
                    props: {
                        modeWhiteList: [
                            'heat',
                            'cool',
                            'auto',
                            'fanOnly',
                            'off',
                        ],
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.HVAC,
                            controlId: 10,
                        },
                    ],
                },
            ],
        },
        {
            id: 5,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Modes',
            },
        },
        {
            id: 6,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Square',
                    props: {
                        mode: 'On Board',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.MODE,
                            controlId: 11,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'Square',
                    props: {
                        mode: 'Away',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.MODE,
                            controlId: 13,
                        },
                    ],
                },
                {
                    id: 3,
                    form: 'Square',
                    props: {
                        mode: 'Sleep',
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.MODE,
                            controlId: 12,
                        },
                    ],
                },
            ],
        },
        {
            id: 7,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Battery',
            },
        },
        {
            id: 8,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'FullWidth',
                    bindings: [
                        {
                            kind: 'synthetic',
                            type: UIComponent_1.SyntheticType.BatteryDisconnect,
                            controlId: 8,
                            props: {
                                timeoutOverride: 15000,
                            },
                        },
                    ],
                },
            ],
        },
    ],
    monitor: [
        {
            id: 1,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Systems',
                includeConnectionText: true,
            },
        },
        {
            id: 2,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'synthetic',
                            type: UIComponent_1.SyntheticType.Router,
                        },
                    ],
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    props: {
                        disableWhenBatteryDisconnected: true,
                    },
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.SHORE_POWER,
                            controlId: 7,
                        },
                    ],
                },
            ],
        },
        {
            id: 3,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.BATTERY,
                            controlId: 8,
                        },
                    ],
                    tileLabelOverride: 'House Battery',
                },
                {
                    id: 2,
                    form: 'Rectangle',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.BATTERY,
                            controlId: 9,
                        },
                    ],
                    tileLabelOverride: 'Chassis Battery',
                },
            ],
        },
        {
            id: 4,
            type: UIComponentType_1.UIComponentType.Heading,
            props: {
                text: 'Tank Levels',
            },
        },
        {
            id: 5,
            type: UIComponentType_1.UIComponentType.Row,
            contents: [
                {
                    id: 1,
                    form: 'Tanks',
                    bindings: [
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 6,
                            props: {
                                tankType: 'propane',
                            },
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 3,
                            props: {
                                tankType: 'freshWater',
                            },
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 4,
                            props: {
                                tankType: 'greyWater',
                            },
                        },
                        {
                            kind: 'vehicle',
                            type: ComponentType_1.ComponentType.TANK,
                            controlId: 5,
                            props: {
                                tankType: 'wasteWater',
                            },
                        },
                    ],
                },
            ],
        },
        {
            id: 6,
            type: UIComponentType_1.UIComponentType.LastUpdated,
        },
        {
            id: 7,
            type: UIComponentType_1.UIComponentType.Alerts,
        },
    ],
    components: [
        {
            id: 1,
            iid: [
                13,
            ],
            name: 'Overhead Lights',
            type: ComponentType_1.ComponentType.LIGHT,
            props: {
                dimmable: true,
                maxActuationTimeInMs: 10000,
            },
        },
        {
            id: 2,
            iid: [
                15,
            ],
            name: 'Porch Lights',
            type: ComponentType_1.ComponentType.LIGHT,
            props: {
                dimmable: false,
            },
        },
        {
            id: 3,
            iid: [
                16,
                31,
            ],
            name: 'Fresh Water',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 50,
                hasHeater: true,
                heaterIid: 31,
            },
        },
        {
            id: 4,
            iid: [
                34,
            ],
            name: 'Grey Water',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 50,
                hasHeater: false,
            },
        },
        {
            id: 5,
            iid: [
                81,
            ],
            name: 'Waste Water',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 50,
                hasHeater: false,
            },
        },
        {
            id: 6,
            iid: [
                3,
            ],
            name: 'LPG',
            type: ComponentType_1.ComponentType.TANK,
            props: {
                capacity: 9,
                hasHeater: false,
            },
        },
        {
            id: 7,
            iid: [
                24,
            ],
            name: '120V Power',
            type: ComponentType_1.ComponentType.SHORE_POWER,
        },
        {
            id: 8,
            iid: [
                0,
                44,
            ],
            name: 'House Battery',
            type: ComponentType_1.ComponentType.BATTERY,
            props: {
                disconnectIid: 44,
                hasDisconnect: true,
                maxActuationTimeInMs: 15000,
            },
        },
        {
            id: 9,
            iid: [
                1,
                44,
            ],
            name: 'Chassis Battery',
            type: ComponentType_1.ComponentType.BATTERY,
            props: {
                disconnectIid: 44,
                hasDisconnect: false,
            },
        },
        {
            id: 10,
            iid: [
                0,
                38,
                40,
                41,
            ],
            name: 'Front HVAC',
            type: ComponentType_1.ComponentType.HVAC,
            props: {
                modes: [
                    'heat',
                    'cool',
                    'auto',
                    'aux',
                    'auxAuto',
                    'auxHeat',
                ],
                canLock: true,
                modeIid: 38,
                fanSpeeds: 2,
                setTempIid: 41,
                fanSpeedIid: 40,
                maxTemperature: 85,
                minTemperature: 65,
            },
        },
        {
            id: 11,
            iid: [
                62,
            ],
            name: 'On Board Mode',
            type: ComponentType_1.ComponentType.MODE,
        },
        {
            id: 12,
            iid: [
                63,
            ],
            name: 'Sleep Mode',
            type: ComponentType_1.ComponentType.MODE,
        },
        {
            id: 13,
            iid: [
                65,
            ],
            name: 'Away Mode',
            type: ComponentType_1.ComponentType.MODE,
        },
        {
            id: 14,
            iid: [
                21,
            ],
            name: 'Entry Shade',
            type: ComponentType_1.ComponentType.WINDOW_SHADE,
            props: {
                shadeIid: 21,
            },
        },
        {
            id: 15,
            iid: [
                20,
            ],
            name: 'Slide Out Shades',
            type: ComponentType_1.ComponentType.WINDOW_SHADE,
            props: {
                shadeIid: 20,
            },
        },
        {
            id: 16,
            iid: [
                5,
                12,
                28,
                29,
            ],
            name: 'Awning',
            type: ComponentType_1.ComponentType.DUMB_AWNING,
            props: {
                openIid: 28,
                closeIid: 29,
                hasLight: true,
                lightIid: 12,
            },
        },
    ],
    scheduling: [],
    updatedAt: '2020-02-26T22:12:00Z',
};
//# sourceMappingURL=atlas.js.map